import React from 'react';
import { isEmpty } from 'lodash';
import noImage from '../../../assets/images/no-image.png';
import CustomTooltip from '../../../Components/Tooltip/CustomTooltip';

function UserInstructionImage({ dataValue, isPageDisable, handleImageUpload, handleImageDelete, t }) {
  const setImage = (image) => {
    let imagePath = '';
    if (image?.includes('data:image/')) {
      imagePath = image;
    } else if (image) {
      imagePath = `https://${process.env.REACT_APP_BUCKET_NAME}.s3.${process.env.REACT_APP_AWS_REGION}.amazonaws.com/${image}`;
    } else {
      imagePath = noImage;
    }
    return imagePath;
  };

  return (
    <div className="image-container mr-0 d-flex">
      <div>
        <img width="70px" height="70px" src={setImage(dataValue?.image)} alt="croppedImage" />
      </div>
      {!isPageDisable && (
        <div className="d-flex flex-column">
          <CustomTooltip placement="top" tooltipText={t('SPEC_TEMP_LIBRARY.UPLOAD_IMAGE')}>
            <button aria-label="upload" className="btn btn-upload-img" onClick={handleImageUpload} type="button">
              <span className="icon-Upload-1" aria-hidden="true" />
            </button>
          </CustomTooltip>
          {!isEmpty(dataValue?.image) && (
            <CustomTooltip placement="top" tooltipText={t('SPEC_TEMP_LIBRARY.REMOVE_IMAGE')}>
              <button aria-label="delete" className="btn btn-upload-img" onClick={handleImageDelete} type="button">
                <span className="icon-Delete" aria-hidden="true" />
              </button>
            </CustomTooltip>
          )}
        </div>
      )}
    </div>
  );
}

export default UserInstructionImage;
